import { CHECKOUT_INTENTS } from '../constants/checkoutAttribution';

const INTENT_KEY = 'lockedin_checkout_intent';
const OPEN_CREATE_GROUP_KEY = 'lockedin_open_create_group';

export function setCheckoutIntent(intent) {
  if (!intent || typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(INTENT_KEY, intent);
  } catch (_) {
    /* ignore */
  }
}

export function consumeCheckoutIntent() {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.sessionStorage.getItem(INTENT_KEY);
    window.sessionStorage.removeItem(INTENT_KEY);
    return value;
  } catch (_) {
    return null;
  }
}

export function peekCheckoutIntent() {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(INTENT_KEY);
  } catch (_) {
    return null;
  }
}

export function setOpenCreateGroupFlag() {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(OPEN_CREATE_GROUP_KEY, '1');
  } catch (_) {
    /* ignore */
  }
}

export function setOpenCreateGroupAfterCheckout() {
  setCheckoutIntent(CHECKOUT_INTENTS.CREATE_LEAGUE);
  setOpenCreateGroupFlag();
}

export function peekOpenCreateGroupPending() {
  if (typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(OPEN_CREATE_GROUP_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export function consumeOpenCreateGroupFlag() {
  if (typeof window === 'undefined') return false;
  try {
    const value = window.sessionStorage.getItem(OPEN_CREATE_GROUP_KEY);
    window.sessionStorage.removeItem(OPEN_CREATE_GROUP_KEY);
    return value === '1';
  } catch (_) {
    return false;
  }
}

export function isJoinCapError(message) {
  const text = String(message || '');
  return text.includes('Free accounts can join up to') || text.includes('Upgrade to LockedIn Plus for unlimited groups');
}
